export default "__VITE_ASSET__2b3bc00a__"